import styled, { css } from 'styled-components';

export const CloseButton = styled.button`
  ${({ theme }) => css`
    background-color: ${theme.palette.primary.dark};
    position: absolute;
    top: -10px;
    right: -10px;
    border-radius: ${theme.borderRadius.full};
    color: ${theme.palette.neutral[100]};
    cursor: pointer;
    width: 24px;
    height: 24px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
    border-color: transparent;
    z-index: 2000;

    &:hover {
      transform: scale(1.2);
    }

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
    }
  `}
`;
